import { Component } from '@angular/core';
import { UserActivityService } from '@app/user-activity/user-activity.service';
import { TrainingDetails } from '@app/user-activity/types';
import { NotificationsService } from '@shared/notifications.service';

@Component({
    selector: 'app-user-training-activity-details-modal',
    templateUrl: './user-training-activity-details-modal.component.html',
    styleUrls: ['./user-training-activity-details-modal.component.scss'],
    standalone: false
})
export class UserTrainingActivityDetailsModalComponent {
    showModal = false;
    isClosing = false;
    isLoading = false;
    activityDetails: TrainingDetails | null = null;

    constructor(
        private userActivityService: UserActivityService,
        private notifications: NotificationsService
    ) {}

    open(trainingActivityId: number): void {
        this.isClosing = false;
        this.showModal = true;
        this.isLoading = true;
        this.activityDetails = null;

        this.userActivityService.getTrainingDetails(trainingActivityId)
            .then((response) => {
                if (!response.error) {
                    this.activityDetails = response.data as TrainingDetails;
                    return;
                }

                this.notifications.error('Error', 'Failed to load activity details.');
                this.close();
            })
            .catch(() => {
                this.notifications.error('Error', 'Failed to load activity details.');
                this.close();
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    close(): void {
        this.isClosing = true;
        setTimeout(() => {
            this.showModal = false;
            this.isClosing = false;
            this.activityDetails = null;
        }, 180);
    }

    formatDuration(seconds: number | undefined): string {
        if (!seconds) {
            return '-';
        }

        const minutes = Math.floor(seconds / 60);
        return `${minutes} min`;
    }

    formatTime(seconds: number | undefined): string {
        if (!seconds) {
            return '';
        }

        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }

    formatIntensity(intensity: number | undefined): string {
        if (intensity === undefined || intensity === null) {
            return '-';
        }

        return `${intensity}: ${this.getIntensityLabel(intensity)}`;
    }

    private getIntensityLabel(intensity: number): string {
        const labels: Record<number, string> = {
            1: 'Low',
            2: 'Moderate',
            3: 'High',
            4: 'Very High',
            5: 'Extreme'
        };

        return labels[intensity] || 'Unknown';
    }
}
